export const DEFAULT_WIDGET_ICON = 'customModules';
export const WIDGET_ICON_MAP = Object.freeze({
  widget_container: 'flexColumn',
  cell: 'groupModule',
  virtual_cell: 'flexColumn',
  global_group: 'partial',
  global_widget: DEFAULT_WIDGET_ICON,
  section_delimiter: DEFAULT_WIDGET_ICON
});